import { render, staticRenderFns } from "./WhoAreWe.vue?vue&type=template&id=18c1e86a&"
import script from "./WhoAreWe.vue?vue&type=script&lang=js&"
export * from "./WhoAreWe.vue?vue&type=script&lang=js&"
import style0 from "./WhoAreWe.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports